<micro-lookup domain="ussd" obj="ussdCarriers" url="/ussdCarriers" [key]="ussdCarrierId"></micro-lookup>
